
/* STAHLOR PRODUCT PREMIUM REBUILD V2 */
(function () {
  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  function hideNativeRelatedBlocks() {
    var headings = Array.prototype.slice.call(document.querySelectorAll("h1,h2,h3"));
    headings.forEach(function (h) {
      if (h.closest(".stahlor-product-related-v2")) return;

      var txt = (h.textContent || "").trim().toLowerCase();

      var shouldHide =
        txt === "recently viewed" ||
        txt === "you may also like" ||
        txt.indexOf("recently viewed") >= 0 ||
        txt.indexOf("you may also like") >= 0 ||
        txt.indexOf("related products you may also need") >= 0;

      if (!shouldHide) return;

      var node = h;
      /* IE-0929-d9f96c: tırmanma başlığın kendi bölümünde kalır; <main>, <body> ve ürün formunu/başlığını
         içeren kapsayıcı asla gizlenmez (koleksiyonsuz ürünlerde tüm <main> gizleniyordu). */
      var section = h.closest(".shopify-section");
      for (var i = 0; i < 8; i++) {
        if (!node || !node.parentElement) break;

        var parent = node.parentElement;
        if (parent === document.body || parent.tagName === "MAIN") break;
        if (section && !section.contains(parent)) break;
        if (parent.querySelector('#popup_cart_title, form[action*="/cart/add"]#AddToCartForm')) break;
        var productLinks = parent.querySelectorAll('a[href*="/products/"]').length;
        var imgs = parent.querySelectorAll("img").length;
        var textLen = (parent.textContent || "").trim().length;

        if (productLinks >= 2 || imgs >= 2 || textLen > 80) {
          parent.classList.add("stahlor-hide-native-related");
          break;
        }

        node = parent;
      }
    });
  }

  function normalizeProductImages() {
    var imgs = document.querySelectorAll(".stahlor-product-related-v2 img");
    imgs.forEach(function (img) {
      img.removeAttribute("width");
      img.removeAttribute("height");
      img.style.objectFit = "contain";
    });
  }

  ready(function () {
    document.body.classList.add("stahlor-product-premium-v2");
    hideNativeRelatedBlocks();
    normalizeProductImages();

    setTimeout(function () {
      hideNativeRelatedBlocks();
      normalizeProductImages();
    }, 600);

    setTimeout(function () {
      hideNativeRelatedBlocks();
      normalizeProductImages();
    }, 1600);
  });
})();
